/**
 * Minimal toast notification store — singleton outside Pinia for cheapness.
 *
 * Avoids pulling a 3rd-party toast lib. Component `<ToastHost />` renders the
 * stack; any caller does `useToast().push({ type, message })`.
 */
import { reactive } from "vue";

export type ToastKind = "success" | "error" | "info";
/** Необязательная ссылка-действие в тосте («Открыть „Выгрузки" →») — для «job запущен → посмотреть». */
export interface ToastAction {
  label: string;
  /** Router path, напр. "/exports". */
  to: string;
}
export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  action?: ToastAction;
}

const state = reactive<{ toasts: Toast[] }>({ toasts: [] });
let seq = 0;

export function useToast() {
  function push(t: { kind: ToastKind; message: string; ttlMs?: number; action?: ToastAction }): number {
    const id = ++seq;
    state.toasts.push({ id, kind: t.kind, message: t.message, action: t.action });
    // Тост с действием живёт дольше — надо успеть кликнуть по ссылке.
    const ttl = t.ttlMs ?? (t.kind === "error" ? 6000 : t.action ? 7000 : 3500);
    setTimeout(() => dismiss(id), ttl);
    return id;
  }

  function dismiss(id: number): void {
    const i = state.toasts.findIndex((x) => x.id === id);
    if (i >= 0) state.toasts.splice(i, 1);
  }

  return { state, push, dismiss };
}
